"use client";

import React from "react";
import { SliceZone } from "@prismicio/react";
import { components } from "@/slices";

export default function CFooter({ slices }) {
  const legalInfoSlices = slices?.filter(slice => slice.slice_type === 'legal_info') || [];
  const footerNavSlices = slices?.filter(slice => slice.slice_type === 'footer_nav_items') || [];
  const otherSlices = slices?.filter(slice =>
    slice.slice_type !== 'legal_info' &&
    slice.slice_type !== 'footer_nav_items'
  ) || [];

  return (
    <footer className="w-full border-t-[0.5px] border-graphite">
      <div className="bg-green-light py-10 md:py-12">
        <div className="max-w-400 mx-auto w-full px-8 md:px-16 flex flex-col md:flex-row gap-8 justify-between">
          <SliceZone slices={otherSlices} components={components} />
          <div className="flex flex-col md:flex-row gap-8 md:gap-16">
            <SliceZone slices={footerNavSlices} components={components} />
          </div>
        </div>
      </div>
      <div className="bg-[#FAF6F0] py-2 md:py-3 border-t-[0.5px] border-graphite">
        <div className="max-w-400 mx-auto w-full px-8 md:px-16">
          <SliceZone slices={legalInfoSlices} components={components} />
        </div>
      </div>
    </footer>
  );
}
